// Mock data for Da Vinci Institut

export const instructors = [
  {
    id: 1,
    name: "Sarah Müller",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop",
    studies: "Lehramt für Deutsch und Geschichte, Universität zu Köln",
    subjects: ["Deutsch", "Geschichte"],
    comment: "Es ist mir eine Freude, Schülern die deutsche Sprache und Geschichte näherzubringen. Jedes Kind hat sein eigenes Lerntempo, und ich passe meinen Unterricht individuell an."
  },
  {
    id: 2,
    name: "Michael Schmidt",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
    studies: "Lehramt für Mathematik und Physik, RWTH Aachen",
    subjects: ["Mathematik", "Physik"],
    comment: "Mathematik ist überall um uns herum. Ich zeige meinen Schülern, wie spannend und praktisch Mathe sein kann, wenn man die richtigen Methoden kennt."
  },
  {
    id: 3,
    name: "Julia Weber",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop",
    studies: "Lehramt für Englisch und Spanisch, Universität Düsseldorf",
    subjects: ["Englisch", "Spanisch"],
    comment: "Sprachen öffnen Türen zur Welt. Mit interaktiven Methoden und viel Geduld helfe ich Schülern, ihre Sprachkenntnisse zu verbessern."
  },
  {
    id: 4,
    name: "Thomas Becker",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop",
    studies: "Lehramt für Mathematik und Chemie, Universität Bonn",
    subjects: ["Mathematik", "Chemie"],
    comment: "Ich glaube daran, dass jeder Schüler Mathematik verstehen kann. Mit den richtigen Erklärungen und Übungen wird auch die schwierigste Aufgabe lösbar."
  },
  {
    id: 5,
    name: "Laura Fischer",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop",
    studies: "Lehramt für Deutsch und Pädagogik, Universität zu Köln",
    subjects: ["Deutsch", "Pädagogik"],
    comment: "Als angehende Lehrerin ist es meine Leidenschaft, Kindern nicht nur Wissen zu vermitteln, sondern auch ihre Begeisterung fürs Lernen zu wecken."
  },
  {
    id: 6,
    name: "Daniel Hoffmann",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop",
    studies: "Lehramt für Englisch und Sport, Sporthochschule Köln",
    subjects: ["Englisch", "Sport"],
    comment: "Lernen sollte Spaß machen! Ich bringe Bewegung und Aktivität in meinen Unterricht und zeige, dass Englisch lernen alles andere als langweilig ist."
  },
  {
    id: 7,
    name: "Anna Zimmermann",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
    studies: "Lehramt für Biologie und Chemie, Universität Münster",
    subjects: ["Biologie", "Chemie"],
    comment: "Die Naturwissenschaften sind faszinierend! Ich liebe es, Schülern die Wunder der Natur zu zeigen und komplexe Themen verständlich zu erklären."
  }
];

export const courses = [
  {
    id: 1,
    title: "Sprachförderung",
    description: "Individuelle Förderung für Kinder mit Deutsch als Zweitsprache oder Sprachentwicklungsverzögerungen.",
    icon: "MessageCircle",
    grades: "1. - 13. Klasse"
  },
  {
    id: 2,
    title: "ZP-Vorbereitungskurse",
    description: "Intensive Vorbereitung auf die Zentralen Prüfungen in den Hauptfächern mit bewährten Lernmethoden.",
    icon: "GraduationCap",
    grades: "10. Klasse"
  },
  {
    id: 3,
    title: "Deutsch",
    description: "Von Grundlagen bis zum Abitur - Grammatik, Rechtschreibung, Textanalyse und kreatives Schreiben.",
    icon: "BookOpen",
    grades: "1. - Q2 (Abitur)"
  },
  {
    id: 4,
    title: "Mathematik",
    description: "Verständliche Erklärungen für alle mathematischen Themen vom kleinen Einmaleins bis zur Analysis.",
    icon: "Calculator",
    grades: "1. - Q2 (Abitur)"
  },
  {
    id: 5,
    title: "Englisch",
    description: "Sprachkompetenz aufbauen - von ersten Vokabeln bis zu fließenden Konversationen und Textanalysen.",
    icon: "Globe",
    grades: "1. - Q2 (Abitur)"
  },
  {
    id: 6,
    title: "BuT-Förderung",
    description: "Unsere Kurse können über Bildung und Teilhabe (BuT) finanziert werden. Kontaktieren Sie uns für Details.",
    icon: "Heart",
    grades: "Alle Klassen"
  }
];

export const classLevels = [
  "1. Klasse",
  "2. Klasse",
  "3. Klasse",
  "4. Klasse",
  "5. Klasse",
  "6. Klasse",
  "7. Klasse",
  "8. Klasse",
  "9. Klasse",
  "10. Klasse",
  "11. Klasse (EF)",
  "12. Klasse (Q1)",
  "13. Klasse (Q2/Abitur)"
];

export const subjects = [
  "Deutsch",
  "Mathematik",
  "Englisch",
  "Französisch",
  "Spanisch",
  "Latein",
  "Geschichte",
  "Biologie",
  "Chemie",
  "Physik",
  "Erdkunde",
  "Politik",
  "Andere"
];
